export function getColor(value) {
  switch (value) {
    case 'COMPLETED':
      return 'green'
    case 'ERROR':
      return 'red'
    default:
      return 'black'
  }
}
